"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var container = {
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    backgroundColor: 'transparent' // fix 0.36 bug, see: https://github.com/facebook/react-native/issues/10782
};
exports.default = {
    container: container
};
//# sourceMappingURL=image-zoom.style.js.map